module.exports = __webpack_public_path__ + "media/application/images/svgs/tag-c939b85c9c9753918c85eb8ca306d8bf.svg";